/* eslint-disable import/no-anonymous-default-export */
import { Button } from "antd";
import styled from "styled-components";
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';

const Container = styled.div`
`;

export interface Base64UploadProps {
    imgHeight?: number
    value?: string
    onChange?: (value?: string) => any
};

export default (props: Base64UploadProps) => {
    const toBase64 = (file: File): Promise<string | undefined> => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString());
        reader.onerror = error => reject(error);
    });

    const cleanImage = () => {
        props.onChange?.("");
    };


    const loadImage = () => {
        const input = document.createElement("input");
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (evt: any) => {
            const files = evt.target.files as FileList;
            const file = files.item(0);
            if (file) {
                const base64 = await toBase64(file);
                props.onChange?.(base64);
            }
        }
        input.click();

    };

    return (<Container>
        {props.value && props.imgHeight !== 0 &&
            <img style={{ height: props.imgHeight ?? 150, maxWidth: '100%', objectFit: 'contain', width: "auto", marginBottom: 10 }} src={props.value} />}
        <Button style={{ marginRight: 10 }} onClick={loadImage} icon={<UploadOutlined />}>Cargar imagen</Button>
        <Button disabled={!props.value} onClick={cleanImage} icon={<DeleteOutlined />}>Limpiar imagen</Button>
    </Container>);

};